import { render, staticRenderFns } from "./TimelinePeriod.vue?vue&type=template&id=2b78be33&scoped=true"
import script from "./TimelinePeriod.vue?vue&type=script&lang=js"
export * from "./TimelinePeriod.vue?vue&type=script&lang=js"
import style0 from "./TimelinePeriod.vue?vue&type=style&index=0&id=2b78be33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b78be33",
  null
  
)

export default component.exports